import { render, staticRenderFns } from "./YTPlayList.vue?vue&type=template&id=1f8485bc"
import script from "./YTPlayList.vue?vue&type=script&lang=js"
export * from "./YTPlayList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports